export default __webpack_public_path__ + "static/media/Google.d3fe9b68.PNG";